export const isObject = (obj) => {
    return Object.prototype.toString.call(obj) === "[object Object]"
}
export const isString = (str) => {
    return Object.prototype.toString.call(str) === "[object String]"
}
export const isEvent = (ev) => {
    return Object.prototype.toString.call(ev) === "[object PointerEvent]"
}
//处理登录时用户信息
export const getLocalUserInfo = () => {
    const userinfo = JSON.parse(localStorage.getItem('loginInfo'))
    if (userinfo) {
        return userinfo
    }else {
        return null
    }
}
//右箭头
export const nextFn = () =>{
    history.forward()
}

//保留小数,小数与float相同时返回Number类型否则返回值为String类型
export const toFixed = (num,float) => {
    const _float = float || 2
    let nums = Math.round(num*Math.pow(10,_float)) / Math.pow(10,_float)
    let count;
    let zoroStr = ""
    const strArr = nums.toString().split(".")
    if (strArr.length === 1) {
        const len = _float;
        for(let i = 0; i< len; ++i) {
            zoroStr += "0"
        }
        count = strArr[0]+'.'+zoroStr
        return count
    } else if(strArr[1].length < _float) {
        const len = _float - strArr[1].length
        for(let i = 0; i < len; ++i) {
            zoroStr += "0"
        }
        count = strArr[0]+'.'+strArr[1]+zoroStr
        return count
    }
    return nums
}